var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"desktop button",attrs:{"left":"","absolute":""},on:{"click":function($event){return _vm.back()}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v(" mdi-arrow-left ")])],1),_c('BabyCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }